// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Input,
//   Heading,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Flex,
//   Select,
//   Text,
//   VStack,
//   Grid,
//   useToast,
// } from '@chakra-ui/react';
// import * as XLSX from 'xlsx';

// interface Transaccion {
//   ID: number;
//   Concepto: string;
//   RazonSocial: string;
//   MetodoPago: string;
//   Monto: number | null;
//   UUID: string;
//   Fecha: string;
//   IDTransacc: string;
// }

// const HistorialTransacciones: React.FC = () => {
//   const [transactions, setTransactions] = useState<Transaccion[]>([]);
//   const [page, setPage] = useState(1);
//   const [pageSize] = useState(500);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [conceptoFilter, setConceptoFilter] = useState('');
//   const [razonSocialFilter, setRazonSocialFilter] = useState('');
//   const [metodoPagoFilter, setMetodoPagoFilter] = useState('');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const toast = useToast();

//   const fetchTransactions = async () => {
//     try {
//       const params = new URLSearchParams({
//         page: page.toString(),
//         pageSize: pageSize.toString(),
//         search: searchTerm,
//         concepto: conceptoFilter,
//         razonSocial: razonSocialFilter,
//         metodoPago: metodoPagoFilter,
//         startDate,
//         endDate,
//       });

//       const response = await fetch(
//         `http://52.91.130.91:5000/api/Transacciones?${params.toString()}`
//       );
//       const data = await response.json();
//       setTransactions(data.data);
//       setTotalPages(data.pagination.totalPages);
//     } catch (error) {
//       toast({
//         title: 'Error',
//         description: 'No se pudieron cargar los datos de las transacciones.',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   };

//   useEffect(() => {
//     fetchTransactions();
//   }, [page, pageSize]);

//   const applyFilters = () => {
//     setPage(1); // Reiniciar a la primera página al aplicar filtros
//     fetchTransactions();
//   };

//   const downloadExcel = () => {
//     const ws = XLSX.utils.json_to_sheet(transactions);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Transacciones');
//     XLSX.writeFile(wb, 'transacciones.xlsx');
//   };

//   return (
//     <Box p={5}>
//       <Heading mb={6} textAlign="center">Historial de Transacciones</Heading>
//       <Grid templateColumns="repeat(4, 1fr)" gap={4} mb={6}>
//         <Input
//           placeholder="Buscar por ID Transacc"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <Select
//           placeholder="Filtrar por Concepto"
//           value={conceptoFilter}
//           onChange={(e) => setConceptoFilter(e.target.value)}
//         >
//           {[...new Set(transactions.map((t) => t.Concepto))].map((concepto) => (
//             <option key={concepto} value={concepto}>
//               {concepto}
//             </option>
//           ))}
//         </Select>
//         <Input
//           placeholder="Filtrar por Razón Social"
//           value={razonSocialFilter}
//           onChange={(e) => setRazonSocialFilter(e.target.value)}
//         />
//         <Select
//           placeholder="Filtrar por Método de Pago"
//           value={metodoPagoFilter}
//           onChange={(e) => setMetodoPagoFilter(e.target.value)}
//         >
//           {[...new Set(transactions.map((t) => t.MetodoPago))].map((metodo) => (
//             <option key={metodo} value={metodo}>
//               {metodo}
//             </option>
//           ))}
//         </Select>
//         <Input
//           type="date"
//           placeholder="Fecha inicio"
//           value={startDate}
//           onChange={(e) => setStartDate(e.target.value)}
//         />
//         <Input
//           type="date"
//           placeholder="Fecha fin"
//           value={endDate}
//           onChange={(e) => setEndDate(e.target.value)}
//         />
//         <Button onClick={applyFilters} colorScheme="teal">
//           Aplicar Filtros
//         </Button>
//         <Button onClick={downloadExcel} colorScheme="blue">
//           Descargar CSV/XLSX
//         </Button>
//       </Grid>

//       <Box
//         overflowY="auto"
//         overflowX={"auto"}
//         maxH="650px"
//         border="1px solid"
//         borderColor="gray.200"
//         borderRadius="md"
//       >
//         <Table variant="striped" colorScheme="gray">
//           <Thead>
//             <Tr>
//               <Th>ID</Th>
//               <Th>Concepto</Th>
//               <Th>Razón Social</Th>
//               <Th>Método de Pago</Th>
//               <Th>Monto</Th>
//               <Th>Fecha</Th>
//               <Th>ID Transacc</Th>
//               <Th>UUID</Th>

//             </Tr>
//           </Thead>
//           <Tbody>
//             {transactions.map((transaction) => (
//               <Tr key={transaction.ID}>
//                 <Td>{transaction.ID}</Td>
//                 <Td>{transaction.Concepto}</Td>
//                 <Td>{transaction.RazonSocial}</Td>
//                 <Td>{transaction.MetodoPago}</Td>
//                 <Td>
//                   {transaction.Monto !== null
//                     ? `$${transaction.Monto.toFixed(2)}`
//                     : 'N/A'}
//                 </Td>
//                 <Td>{new Date(transaction.Fecha).toLocaleDateString()}</Td>
//                 <Td>{transaction.IDTransacc}</Td>
//                 <Td>{transaction.UUID}</Td>

//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       </Box>

//       <Flex justifyContent="space-between" mt={4}>
//         <Button
//           onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
//           isDisabled={page === 1}
//         >
//           Anterior
//         </Button>
//         <Text>
//           Página {page} de {totalPages}
//         </Text>
//         <Button
//           onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
//           isDisabled={page === totalPages}
//         >
//           Siguiente
//         </Button>
//       </Flex>
//     </Box>
//   );
// };

// export default HistorialTransacciones;
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  lazy,
  Suspense,
} from 'react';
import { Menu, MenuButton, MenuList, MenuItem, Checkbox } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Input,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Select,
  Text,
  Grid,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
  HStack,
} from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import axios from 'axios';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from 'chart.js';
import TransaccionDetails from 'views/Pagos/DetallePagos';
import LoadingOverlay from 'components/cargando/loading';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  ChartDataLabels,
);

const CajaGeneral = lazy(() => import('../Facturacion/CajaGeneral')); // Lazy load del componente

interface Transaccion {
  ID: number;
  Concepto: string;
  RazonSocial: string;
  MetodoPago: string;
  estatus_de_cancelacion:string;
  Monto: number | null;
  UUID: string;
  Fecha: string;
  IDTransacc: string;
}

const HistorialTransacciones: React.FC = () => {
  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }); // Ejemplo: "December 7, 2024"
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Sumar 1 día
  const formattedTomorrow = tomorrow.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const [FilteredTransactions, setFilteredTransactions] = useState<Transaccion[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [transactions, setTransactions] = useState<Transaccion[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10000);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [conceptoFilter, setConceptoFilter] = useState('');
  const [razonSocialFilter, setRazonSocialFilter] = useState('');
//  const [estatusFilter, setEstatusFilter] = useState(false);
  const [estatusFilter, setEstatusFilter] = useState('TODOS'); // Estado del filtro

  const [razonSocialFilterx, setRazonSocialFilterx] = useState('');

  const [metodoPagoFilter, setMetodoPagoFilter] = useState('');
  const [startDate, setStartDate] = useState(today);

  const [endDate, setEndDate] = useState(formattedTomorrow);

  const [selectedTransaction, setSelectedTransaction] =
    useState<Transaccion | null>(null);

  const toast = useToast();
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const {
    isOpen: isDetailOpen,
    onOpen: onDetailOpen,
    onClose: onDetailClose,
  } = useDisclosure();

  const fetchTransactions = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        search: searchTerm,
        concepto: conceptoFilter,
        razonSocial: razonSocialFilter,
        metodoPago: metodoPagoFilter,
       startDate,
       endDate,
       Concepto:'PREDIAL'
      });
      setIsLoading(true);

      const response = await fetch(
        `http://52.91.130.91:5000/api/Transacciones?${params.toString()}`,
      );
      const data = await response.json();
      //const data = await response.json();
      const filteredData = data.data.filter(
        (transaction: Transaccion) => transaction.Concepto === 'PREDIAL',
      );
      setTransactions(filteredData);
      //setTransactions(exampleData);
      setFilteredTransactions(filteredData)
      //setTransactions(data.data);
      setTotalPages(data.pagination.totalPages);
      setIsLoading(false);

    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos de las transacciones.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [
    page,
    pageSize,
    searchTerm,
    // conceptoFilter,
    // razonSocialFilter,
    // metodoPagoFilter,
    startDate,
    endDate,
  ]);

  // const applyFilters = useCallback(() => {
  //   const filtered = transactions
  //     .filter((transaction) =>
  //       searchTerm
  //         ? transaction.IDTransacc.toLowerCase().includes(searchTerm.toLowerCase())
  //         : true
  //     )
  //     .filter((transaction) =>
  //       conceptoFilter ? transaction.Concepto === conceptoFilter : true
  //     )
  //     .filter((transaction) =>
  //       razonSocialFilter
  //         ? transaction.RazonSocial.toLowerCase().includes(razonSocialFilter.toLowerCase())
  //         : true
  //     )
  //     .filter((transaction) =>
  //       metodoPagoFilter ? transaction.MetodoPago === metodoPagoFilter : true
  //     )
  //     .filter((transaction) => {
  //       if (!startDate || !endDate) return true;

  //       const transactionDate = new Date(transaction.Fecha);
  //       return (
  //         transactionDate >= new Date(startDate) &&
  //         transactionDate <= new Date(endDate)
  //       );
  //     });

  //   setFilteredTransactions(filtered); // Actualizar las transacciones filtradas
  //   setPage(1); // Reiniciar la paginación
  // }, [
  //   transactions,
  //   searchTerm,
  //   conceptoFilter,
  //   razonSocialFilter,
  //   metodoPagoFilter,
  //   startDate,
  //   endDate,
  // ]);

  const filteredTransactions = useMemo(() => {
    return transactions
      .filter((transaction) =>
        transaction.IDTransacc.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .filter((transaction) =>
        conceptoFilter ? transaction.Concepto === conceptoFilter : true
      )
      .filter((transaction) =>
        razonSocialFilter
          ? transaction.RazonSocial.toLowerCase().includes(
              razonSocialFilter.toLowerCase()
            )
          : true
      )
      .filter((transaction) =>
        metodoPagoFilter
          ? transaction.MetodoPago === metodoPagoFilter
          : true
      )
      .filter((transaction) => {
        if (!startDate || !endDate) return true;
  
        const transactionDate = new Date(transaction.Fecha);
        return (
          transactionDate >= new Date(startDate) &&
          transactionDate <= new Date(endDate)
        );
      });
  }, [
    transactions,
    searchTerm,
    conceptoFilter,
    razonSocialFilter,
    metodoPagoFilter,
    startDate,
    endDate,
  ]);
  

  useEffect(() => {
    fetchTransactions();
  }, []);

  useEffect(() => {
    const filteredData = transactions.filter((transaction) => {
      const matchesRazonSocial = transaction.RazonSocial.toLowerCase().includes(razonSocialFilterx.toLowerCase());

   // Lógica del filtro basado en el estatus seleccionado
   const matchesEstatus =
   estatusFilter === 'TODOS'
     ? true // TODOS incluye todos los registros
     : estatusFilter === 'CANCELADO'
     ? transaction.estatus_de_cancelacion === 'CANCELADO' // Solo cancelados
     : estatusFilter === 'TIMBRADOS'
     ? transaction.estatus_de_cancelacion !== 'CANCELADO' //&& transaction.estatus_de_cancelacion === '' // Solo vacíos sin "CANCELADO"
     : true;
      return matchesRazonSocial && matchesEstatus;
    });

    setFilteredTransactions(filteredData);
   // setFilteredTransactions(filteredData);
  }, [razonSocialFilterx,estatusFilter, transactions]);


  const applyFilters = useCallback(() => {
    setPage(1); // Reiniciar a la primera página al aplicar filtros
    fetchTransactions();
  }, [fetchTransactions]);

  const paginatedTransactions = useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    return transactions.slice(startIndex, startIndex + pageSize);
  }, [page, pageSize, transactions]);

  const groupedData = useMemo(() => {
    return FilteredTransactions.reduce((acc, transaction) => {
      if (transaction.Concepto in acc) {
        acc[transaction.Concepto] += transaction.Monto || 0;
      } else {
        acc[transaction.Concepto] = transaction.Monto || 0;
      }
      return acc;
    }, {} as Record<string, number>);
  }, [FilteredTransactions ]);

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        datalabels: {
          formatter: (value: number) => `$${value.toFixed(2)}`,
          font: {
            size: 12,
          },
          color: 'black',
        },
      },
    }),
    [],
  );

  const chartData = useMemo(() => {
    return {
      labels: Object.keys(groupedData),
      datasets: [
        {
          label: 'Transacciones de Predio',
          data: Object.values(groupedData),
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
        },
      ],
    };
  }, [groupedData]);

  const handleViewDetails = useCallback(
    (transaction: Transaccion) => {
      setSelectedTransaction(transaction);
      onDetailOpen();
    },
    [onDetailOpen],
  );

  const downloadExcel = useCallback(() => {
    const ws = XLSX.utils.json_to_sheet(transactions);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Transacciones');
    XLSX.writeFile(wb, 'transacciones.xlsx');
  }, [transactions]);

  return (
    <Box p={5}>
                  <LoadingOverlay isLoading={isLoading} message="Procesando..." />

      <Heading mb={6} textAlign="center">
        Historial de Transacciones
      </Heading>

      {/* Gráfica */}
      <Box
        mb={6}
        style={{
          maxWidth: '600px',
          maxHeight: '400px',
          margin: '0 auto',
        }}
      >
        <Bar data={chartData} options={chartOptions} />
      </Box>

      {/* Filtros y Acciones */}
      <Flex justifyContent="space-between" mb={6}>
        <Grid templateColumns="repeat(4, 1fr)" gap={4}>
        <Input
        placeholder="Filtrar por Razon Social"
        value={razonSocialFilterx}
        maxW={'480px'}
        onChange={(e) => setRazonSocialFilterx(e.target.value)} // Actualiza el estado al escribir
        focusBorderColor="teal.400" // Color del borde cuando está enfocado
        size="md" // Tamaño del input
        variant="outline" // Estilo del input
      />
       <Select
        placeholder="Selecciona un estatus"
        value={estatusFilter} // Valor actual del filtro
        onChange={(e) => setEstatusFilter(e.target.value)} // Actualiza el estado al cambiar
        colorScheme="teal"
        size="md"
        maxW="320px"
      >
        <option value="">Todos</option>
        <option value="CANCELADO">Cancelados</option>
        <option value="TIMBRADOS">Timbrados</option>
      </Select>
      {/* Checkbox controlado */}
      {/* <Checkbox
        isChecked={estatusFilter} // Controla si está marcado
        onChange={(e) => setEstatusFilter(e.target.checked)} // Actualiza el estado
        colorScheme="teal" // Esquema de color
        size="md" // Tamaño del checkbox
      >
        Cancelados?
      </Checkbox> */}
     
          
        
          <Input
            type="date"
            placeholder="Desde"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <Input
            type="date"
            placeholder="Hasta"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <Button colorScheme="teal" onClick={applyFilters}>
    Aplicar Filtros
  </Button>
        </Grid>
        <HStack spacing={4}>
      
          <Menu>
            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              colorScheme="green"
            >
              Acciones
            </MenuButton>
            <MenuList>
              <MenuItem
                onClick={async () => {
                  if (!startDate || !endDate) {
                    toast({
                      title: 'Error',
                      description: 'Por favor, selecciona ambas fechas.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                    return;
                  }

                  try {
                    const response = await axios.get(
                      `http://52.91.130.91:5000/api/ReportesRoutes/reporte-financiero-pdf?startDate=${startDate}&endDate=${endDate}`,
                      { responseType: 'blob' },
                    );

                    const url = window.URL.createObjectURL(
                      new Blob([response.data]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                      'download',
                      `reporte-financiero-${startDate}-${endDate}.pdf`,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    toast({
                      title: 'Éxito',
                      description: 'Reporte financiero generado correctamente.',
                      status: 'success',
                      duration: 5000,
                      isClosable: true,
                    });
                  } catch (error) {
                    console.error(
                      'Error al generar el reporte financiero:',
                      error,
                    );
                    toast({
                      title: 'Error',
                      description:
                        'No se pudo generar el reporte financiero. Intenta de nuevo.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                  }
                }}
              >
                Reporte Financiero
              </MenuItem>

              <MenuItem
                onClick={async () => {
                  if (!startDate || !endDate) {
                    toast({
                      title: 'Error',
                      description: 'Por favor, selecciona ambas fechas.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                    return;
                  }

                  try {
                    // const response = await axios.get(
                    //   `http://52.91.130.91:5000/api/ReportesRoutes/reporte-financiero-pdf?startDate=${startDate}&endDate=${endDate}`,
                    //   { responseType: 'blob' },
                    // );
   const response = await axios.get(
                      `http://52.91.130.91:5000/api/ReportesRoutes/reporte-recaudo-pdf?startDate=${startDate}&endDate=${endDate}`,
                      { responseType: 'blob' },
                    );
                    const url = window.URL.createObjectURL(
                      new Blob([response.data]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                      'download',
                      `reporte-financiero-${startDate}-${endDate}.pdf`,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    toast({
                      title: 'Éxito',
                      description: 'Reporte de recaudacion generado correctamente.',
                      status: 'success',
                      duration: 5000,
                      isClosable: true,
                    });
                  } catch (error) {
                    console.error(
                      'Error al generar el reporte de recaudo:',
                      error,
                    );
                    toast({
                      title: 'Error',
                      description:
                        'No se pudo generar el reporte de recuado. Intenta de nuevo.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                  }
                }}
              >
                Detalles de Recaudacion
              </MenuItem>
              <MenuItem
                onClick={async () => {
                  if (!startDate || !endDate) {
                    toast({
                      title: 'Error',
                      description: 'Por favor, selecciona ambas fechas.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                    return;
                  }

                  try {
                    const response = await axios.get(
                      `http://52.91.130.91:5000/api/ReportesRoutes/reporte-financiero-pdf-cancelados?startDate=${startDate}&endDate=${endDate}`,
                      { responseType: 'blob' },
                    );

                    const url = window.URL.createObjectURL(
                      new Blob([response.data]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                      'download',
                      `reporte-financiero-cancelados-${startDate}-${endDate}.pdf`,
                    );
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    toast({
                      title: 'Éxito',
                      description: 'Reporte financiero generado correctamente.',
                      status: 'success',
                      duration: 5000,
                      isClosable: true,
                    });
                  } catch (error) {
                    console.error(
                      'Error al generar el reporte financiero:',
                      error,
                    );
                    toast({
                      title: 'Error',
                      description:
                        'No se pudo generar el reporte financiero. Intenta de nuevo.',
                      status: 'error',
                      duration: 5000,
                      isClosable: true,
                    });
                  }
                }}
              >
                Reporte Financiero de Cancelacion
              </MenuItem>
              <MenuItem onClick={downloadExcel}>Descargar XLS</MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Flex>

      {/* Tabla de Transacciones */}
      <Box overflowY="auto" maxH="580px">
        <Table variant="simple" colorScheme="gray">
          <Thead>
          <Tr>
              <Th>ID</Th>
              <Th>Concepto</Th>
              <Th>Razón Social</Th>
              <Th>Método de Pago</Th>
              <Th>Estatus de Cancelacion</Th>

              <Th>Monto</Th>
              <Th>Fecha</Th>
              <Th>Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {FilteredTransactions.map((transaction) => (
                <Tr
                        key={transaction.ID}
                        bgColor={transaction.estatus_de_cancelacion === 'CANCELADO' ? 'red.200' : 'green.100'}
                      fontSize={'sm'}
                      >
                <Td>{transaction.ID}</Td>
                <Td>{transaction.Concepto}</Td>
                <Td>{transaction.RazonSocial}</Td>
                <Td>{transaction.MetodoPago}</Td>

                <Td>{transaction.estatus_de_cancelacion || 'ACTIVO'}</Td>

                <Td>
                  {transaction.Monto !== null
                    ? `$${transaction.Monto.toFixed(2)}`
                    : 'N/A'}
                </Td>
                <Td>{new Date(transaction.Fecha).toLocaleDateString()}</Td>
                <Td>
                  <Button
                    size="sm"
                    onClick={() => handleViewDetails(transaction)}
                  >
                    Ver Detalles
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Paginación */}
      <Flex justifyContent="space-between" mt={4}>
        <Button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
        >
          Anterior
        </Button>
        <Text>
          Página {page} de {totalPages}
        </Text>
        <Button
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
        >
          Siguiente
        </Button>
      </Flex>

      {/* Modal para CajaGeneral */}
      <Modal isOpen={isModalOpen} onClose={onModalClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Nueva Transacción</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Suspense fallback={<Spinner />}>
              <CajaGeneral />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Modal para Ver Detalles */}
      <Modal isOpen={isDetailOpen} onClose={onDetailClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Detalles de Transacción</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <ModalBody>
              {selectedTransaction && (
                <TransaccionDetails
                  transaccionId={selectedTransaction.ID.toString()}
                />
              )}
            </ModalBody>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default HistorialTransacciones;
